module.exports = __webpack_public_path__ + "assets/FundkyLogotype2016_BlancSansPhrase.png";